export default __webpack_public_path__ + "static/media/turnon.b7bd39b5.mp3";